import React, {
  createContext,
  PropsWithChildren,
  useContext,
  useState,
} from "react";
import { LoadingScreen } from "../screens/LoadingScreen";
import { useTranslation } from "react-i18next";

const AppResetContext = createContext<{
  resetCount: number;
  reset: () => void;
}>(null!);

type ResetState = {
  status: "idle" | "resetting";
  resetCount: number;
};

export const AppResetProvider = ({ children }: PropsWithChildren) => {
  const { t } = useTranslation("AppProvider");

  const [resetState, setResetState] = useState<ResetState>({
    status: "idle",
    resetCount: 0,
  });

  const handleReset = () => {
    setResetState((s) => ({ ...s, status: "resetting" }));
    setTimeout(() => {
      setResetState((s) => ({
        status: "idle",
        resetCount: s.resetCount + 1,
      }));
    }, 1000);
  };

  if (resetState.status === "resetting") {
    return <LoadingScreen message={t("Resetting, please wait...")} />;
  }

  return (
    <AppResetContext.Provider
      value={{ resetCount: resetState.resetCount, reset: handleReset }}
    >
      {children}
    </AppResetContext.Provider>
  );
};

export const useAppReset = () => {
  const ctx = useContext(AppResetContext);
  if (ctx == null) {
    throw new Error("useAppReset must be used within an AppResetProvider");
  }
  return ctx;
};
